// extracted by mini-css-extract-plugin
export var header = "_bs-0";